import { render, staticRenderFns } from "./equipment.vue?vue&type=template&id=38607f1b&scoped=true"
import script from "./equipment.vue?vue&type=script&lang=js"
export * from "./equipment.vue?vue&type=script&lang=js"
import style0 from "./equipment.vue?vue&type=style&index=0&id=38607f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38607f1b",
  null
  
)

export default component.exports